import { createContext, ReactNode, useContext } from 'react';

export const NavigationContext = createContext<string | null>(null);

export interface NavigationProviderProps {
  children: ReactNode;
}

export function usePreviousPath(): string | null {
  return useContext(NavigationContext);
}
